module.exports = __webpack_public_path__ + "static/media/timer.4f44d407.svg";